import { Modal } from "antd";
import { useState } from "react";
import carin from "../../../assets/gatein.jpeg";
import carout from "../../../assets/gateout.jpeg";
import Moment from "react-moment";
import Checkpoints from "./Checkpoints";

export default function Timeline({
  isVisible,
  setShowTimeline,
  selected,
}: any) {
  return (
    <Modal
      visible={isVisible}
      title="Vehicle Timeline"
      onCancel={() => setShowTimeline(false)}
      footer={null}
      width={"90%"}
    >
      <div className="flex justify-between items-center h-auto mb-4 font-toyota">
        <div className="border-r pr-2 h-auto mr-2 mb-6 flex-shrink-0">
          <div className="border-b pb-2 mb-4">
            <span className="font-bold">Time In:</span>
            <Moment format="Do, MMM YYYY hh:mm A">{selected?.timein}</Moment>
          </div>
          <img className="mx-auto h-24 w-auto " src={carin} alt="" />
        </div>
        <div className="flex overflow-x-auto ">
          {selected?.checkpoints.map((checkpoint: any, index: number) => (
            <Checkpoints checkpoint={checkpoint} key={index} />
          ))}
        </div>

        <div className="border-l pl-2 h-auto ml-2 mb-6 flex-shrink-0">
          {!selected?.timeout ? null : (
            <>
              <div className="border-b pb-2 mb-6 flex-shrink-0">
                <span className="font-bold ">Time Out:</span>
                <Moment format="Do, MMM YYYY hh:mm A">
                  {selected?.timeout}
                </Moment>
              </div>
              <img className="mx-auto h-24 w-auto " src={carout} alt="" />
            </>
          )}
        </div>
      </div>
    </Modal>
  );
}
